import React from "react";
import { Link } from "react-router-dom";
import { Calendar, Users, MapPin, ArrowUpRight } from "lucide-react";

export default function LeadPostCard({ lead }) {
  return (
    <Link
      to={`/leads/${lead.lead_id}`}
      className="block bg-[#141414] border border-[#262626] rounded-xl p-6 hover:border-[#a3a3a3] transition-colors group"
      data-testid={`lead-card-${lead.lead_id}`}
    >
      <div className="flex items-start justify-between gap-4">
        <div className="flex-1 min-w-0">
          <p className="overline">{lead.type} · {lead.destination}</p>
          <h3 className="font-display text-xl font-bold text-white mt-2 line-clamp-2">{lead.title}</h3>
          <p className="text-sm text-[#a3a3a3] mt-2 line-clamp-2">{lead.description}</p>
        </div>
        <ArrowUpRight className="w-5 h-5 text-[#737373] group-hover:text-brand transition-colors flex-shrink-0" />
      </div>
      <div className="grid grid-cols-3 gap-3 mt-5 pt-5 border-t border-[#1a1a1a]">
        <div>
          <p className="overline">Pax</p>
          <p className="font-mono text-white text-base mt-1">{lead.pax}</p>
        </div>
        <div>
          <p className="overline">Days</p>
          <p className="font-mono text-white text-base mt-1">{lead.duration_days}</p>
        </div>
        <div>
          <p className="overline">Budget</p>
          <p className="font-mono text-white text-base mt-1">${Number(lead.budget_usd).toLocaleString()}</p>
        </div>
      </div>
      <div className="flex items-center justify-between mt-4 text-xs text-[#737373]">
        <span className="flex items-center gap-1.5"><Calendar className="w-3.5 h-3.5" /> {lead.travel_date}</span>
        <span className={`font-mono uppercase tracking-widest ${lead.status === "open" ? "text-brand" : "text-green-400"}`}>
          {lead.bid_count ?? 0} bids · {lead.status}
        </span>
      </div>
    </Link>
  );
}
